module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_28.c1cd9e9a.png";